import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin, Observable, of, Subject } from "rxjs"; // RxJS 6 syntax
import { HttpHeaders } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { environment as env } from "src/environments/environment";
import { HttpService } from "../http/http.service";
import {
  IDepartment,
  IProductPayload,
  IProductsPayload,
  ISearchProductsPayload,
} from "./../../models";
import { map, switchMap } from "rxjs/operators";
import { profile } from "console";

@Injectable({
  providedIn: "root",
})
export class ApiService {


  quizData: any;
  checkedStyleList: any[];
  productList: any[];
  collectionProductList: any[];
  dupProductList: any[];
  dupCollectionProductList: any[];
  toggle: string;
  brandList: any[];
  styleList: any[];
  sortTypeList: any;
  sortType: string;
  gptData: any;
  drawerOpened: boolean;
  blackSaleBanner: any[] = [];
  quizCategory: any;
  isSideNavOpened: boolean;
  dialodClosed$ = new Subject();
  query: any;
  onInitLoaded: boolean;
  onInitLoadedMob: boolean;
  roomId: any;
  quizId: any;
  promoObserver$ = new BehaviorSubject('');
  roomTab$ = new BehaviorSubject('');
  isRoomLandingOpened = true;
  isRoomLandingState$ = new BehaviorSubject(true);
  isAdminSidePanelOpened = true;
  routerDesigner: string;
  quizPromo:string;
  cartProducts: any;
  storedProductDetails: any[] = [];
  storedProductSelection: any[] = [];
  isGalleryModelOpened: boolean;
  searchText = 'What can I help you find?';
  scrollFix = new BehaviorSubject(false);
  deals: any[] = [];
  imgSearchData: { image_url: string; image_upload: File;partner_tier?:any };
  searchProductsPayload: any;
  emitPreviewPanelBack$ = new BehaviorSubject(false);
  callPaymentStripe$ = new BehaviorSubject(false);
  imgSearchURL: string;

  private imgSearchDataSource = new BehaviorSubject<any>(null);
  imgSearchData$ = this.imgSearchDataSource.asObservable();
  paymentId: string;

  private designProjectData  = new BehaviorSubject<any>(null);
  private designIntakeData  = new BehaviorSubject<any>(null);
  

  designProjectData$ = this.designProjectData.asObservable();
  designIntakeData$ = this.designIntakeData.asObservable();

    private searchQueryDataSource = new BehaviorSubject<any>(null);
  searchQueryData$ = this.searchQueryDataSource.asObservable();

  private lastProjectRoomId: string | null = null;
  private lastIntakeRoomId: string | null = null;
  /**
   * Get design project for a room, only fetches from API if not already loaded for this roomId.
   */
  getDesignProjectData(roomId: string): Observable<any> {
    if (this.lastProjectRoomId === roomId && this.designProjectData.value) {
      return this.designProjectData$;
    } else {
      const url = roomId ? `${env.API_BASE_HREF}get_designProject?room_id=${roomId}` : `${env.API_BASE_HREF}get_designProject`;
      return this.httpService.get(url).pipe(
        tap((resp: any) => {
          if (resp && resp[0]) {
            this.setDesignProjectData(resp[0]);
            this.lastProjectRoomId = roomId;
          }
        })
      );
    }
  }

  /**
   * Get design intake for a room, only fetches from API if not already loaded for this roomId.
   */
  getDesignIntakeData(roomId: string, reload=false): Observable<any> {
    if ((this.lastIntakeRoomId === roomId && this.designIntakeData.value) && !reload) {
      return this.designIntakeData$;
    } else {
      const url = `${env.API_BASE_HREF}design_intake?room_id=${roomId}`;
      return this.httpService.get(url).pipe(
        tap((resp: any) => {
          if (resp && resp[0]) {
            this.setDesignIntakeData(resp[0]);
            this.lastIntakeRoomId = roomId;
          }
        })
      );
    }
  }
  
    setImgSearchData(data: any) {
    this.imgSearchDataSource.next(data);
  }

  setDesignProjectData(data: any) {
    this.designProjectData.next(data);
  }

  setDesignIntakeData(data: any) {
    this.designIntakeData.next(data);
  }

 setSearchQueryData(data: any) {
    this.searchQueryDataSource.next(data);
  }
  constructor(
    private httpService: HttpService,
    private cookie: CookieService // private utils: UtilsService
  ) { }

  compareAndUpdate(arr1: any[], arr2: any[]): any[] {
    return arr2.map(newObj => {
      const matchingOldObj = arr1.find(oldObj => oldObj.key === newObj.key);
      if (matchingOldObj && newObj.key !== "size" && newObj.key !== "rug_size"

        && newObj.key !== "bed_size" && newObj.key !== "price" && newObj.key !== "diameter" && newObj.key !== "width" && newObj.key !== "height" && newObj.key !== "length" && newObj.key !== "depth") {
        const newValue = newObj.value.map(newItem => {
          const matchingOldItem = matchingOldObj.value.find(oldItem => oldItem.name === newItem.name);
          return { ...newItem, checked: (matchingOldItem && matchingOldItem.enabled) ? matchingOldItem.checked : false };
        });

        return { ...newObj, value: newValue, opened: matchingOldObj.opened };
      } else {
        if (newObj.key !== "size" && newObj.key !== "rug_size" && newObj.key !== "bed_size" && newObj.key !== "price" && newObj.key !== "diameter" && newObj.key !== "width" && newObj.key !== "height" && newObj.key !== "length" && newObj.key !== "depth") {
          const newValue = newObj.value.map(newItem => ({ ...newItem, checked: false }));
          return { ...newObj, value: newValue };
        }
        return newObj;
      }
    });
  }

  pairKeyValues(input: string): any[] {
    const pairs = input.split(';');
    const result: any[] = [];

    pairs.forEach(pair => {
      const [key, valuesString] = pair.split(':');
      if (!valuesString) {
        return;
      }
      const values = valuesString.split(',');
      result.push({ key: key, value: values });
    });

    return result;
  }



  getDesignProfile(designerId=''): Observable<any> { 
    const url = designerId ? `${env.API_BASE_HREF}designDesigners?designerId=${designerId}` : `${env.API_BASE_HREF}designDesigners`;
    return this.httpService.get(url);
  }
  acuityavaibletime(date: string, desId: string): Observable<any> {
    const url = `${env.API_BASE_HREF}acuityavailabletime?date=${date}&designerId=${desId}`;
    return this.httpService.get(url);
  }
  saveDesignAppointment(data: any): Observable<any> {
    const url = `${env.API_BASE_HREF}save_designAppointment`;
    return this.httpService.post(url, data);
  }
  getApppointment(date, designerId, data): Observable<any> {
    const url = `${env.API_BASE_HREF}appointments?date=${date}&firstName=${data.firstName}&lastName=${data.lastName}&email=${data.email}&phone=${data.phone}&designerId=${designerId}`;
    return this.httpService.get(url);
  }
  getUserByMail(email): Observable<any> {
    const url = `${env.API_BASE_HREF}get_userbymail?email=${email}`;
    return this.httpService.get(url);
  }
  updateDesignUser(data): Observable<any> {
    const url = `${env.API_BASE_HREF}update_designuser`;
    return this.httpService.post(url, data);
  }
  getAllAppointments(email, room_id, userId?): Observable<any> {
    if (email) {
      const url = `${env.API_BASE_HREF}get_designProject?emailid=${email}`;
      return this.httpService.get(url);
    } else if (room_id) {
      const url = `${env.API_BASE_HREF}get_designProject?room_id=${room_id}`;
      return this.httpService.get(url);
    } else if (userId) {
      const url = `${env.API_BASE_HREF}get_designProject?user_id=${userId}`;
      return this.httpService.get(url);
    } else {
      const url = `${env.API_BASE_HREF}get_designProject`;
      return this.httpService.get(url);
    }
  }

  getShoppingList(id, hasState = false, state = null, hasPromo = false, promoCode = null) {
    // const url = `${env.API_BASE_HREF}cart_servicerep?room_id=${id}`;
    // return this.httpService.get(url);

    let endpoint = hasState ? `cart_servicerep?room_id=${id}&state_code=${state}` :
      `cart_servicerep?room_id=${id}`;
    endpoint = hasPromo ? `${endpoint}&promo=${promoCode}` : endpoint;
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url, headers);
  }

  getAdminShoppingList(id: string, page = 0, isShared = null, filter='') {
    // const token = this.cookie.get("token");

    // const headers = new HttpHeaders({
    //   "Content-Type": "application/json",
    //   Authorization: `Bearer ${token}`,
    // });
    let endPoint = '';
    if (isShared === 1) { endPoint = `get_design_product_list/${id}?is_shared=${isShared}&pageno=${page}` } else {
      endPoint = `get_design_product_list/${id}?pageno=${page}`
    }
    if(filter){
      endPoint = `${endPoint}&filters=category:${filter}`;
    }
    const url = `${env.API_BASE_HREF}${endPoint}`;
    return this.httpService.get(url);
  }

  getCartByUserId(id, hasState = false, state = null, hasPromo = false, promoCode = null) {
    // const url = `${env.API_BASE_HREF}cart_servicerep?user_id=${id}`;
    // return this.httpService.get(url);
    let endpoint = hasState ? `cart_servicerep?user_id=${id}&state_code=${state}` :
      `cart_servicerep?user_id=${id}`;
    endpoint = hasPromo ? `${endpoint}&promo=${promoCode}` : endpoint;
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url, headers);
  }

  getNewArrivals(filters = "", page = 0): Observable<IProductsPayload> {
    const endpoint = `products/all`;
    const url = `${env.API_BASE_HREF}${endpoint}?new=true`;
    return this.httpService.get(url);
  }

  getTopDeals(filters = "", page = 0): Observable<IProductsPayload> {
    const endpoint = `products/all`;
    const url = `${env.API_BASE_HREF}${endpoint}?sale=true`;
    return this.httpService.get(url);
  }

  getBlowOutDeals() {
    const dealEndpoint = `v1/blowout-deals`;
    const url = `${env.API_BASE_HREF}${dealEndpoint}`;
    return this.httpService.get(url);
  }

  getTrendingProducts(): Observable<IProductsPayload> {
    const endPoint = `trending`;
    const url = `${env.API_BASE_HREF}${endPoint}`;
    return this.httpService.get(url);
  }

  getBestSellers(filters = "", page = 0): Observable<IProductsPayload> {
    const endpoint = `products/all`;
    const url = `${env.API_BASE_HREF}${endpoint}?bestseller=true`;
    return this.httpService.get(url);
  }

  getEmail(email = "", url = "") {
    const endpoint = "subscribe";
    const path = `${env.API_BASE_HREF}${endpoint}?email=${email}&url=${url}`;
    return this.httpService.get(path);
  }

  getBrands(): Observable<IProductPayload> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.cookie.get("token")}`,
    });
    const url = `${env.API_BASE_HREF}brand`;
    return this.httpService.get(url, headers);
  }

  browseRoom() {
    const endpoint = "all-departments-v1";
    const url = `${env.API_BASE_HREF}${endpoint}?home=true`;
    return this.httpService.get(url);
  }

  bannerData() {
    const endpoint = "banners";
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  getAllProducts(
    trend: string = "",
    total: number,
    filters = "",
    sortType = "",
    page = 0,
    keyword_url = ""
  ): Observable<IProductsPayload> {
    const endpoint = `products/all`;
    let url = "";
    if (trend !== "") {
      url = `${env.API_BASE_HREF}${endpoint}?${trend}=true&limit=${total}&filters=${filters}&sort_type=${sortType}&pageno=${page}`;
    } else {
      url = `${env.API_BASE_HREF}${endpoint}?limit=${total}&filters=${filters}&sort_type=${sortType}&pageno=${page}&keyword_url=${keyword_url}`;
    }
    return this.httpService.get(url);
  }

  getAllProductsUsingKeyword(
    keyword: string,
    total: number,
    filters = "",
    sortType = "",
    page = 0
  ) {
    let url = "";
    if (keyword !== "sale" && keyword !== "new" && keyword !== "all") {
      url = `${env.API_BASE_HREF}products/all?keyword_url=${keyword}&limit=${total}&filters=${filters}&sort_type=${sortType}&pageno=${page}`;
    } else {
      url = `${env.API_BASE_HREF}products/${keyword}?limit=${total}&filters=${filters}&sort_type=${sortType}&pageno=${page}`;
    }
    return this.httpService.get(url);
  }

  getAllProductsWithBrand(
    brand: string,
    trend: string = "",
    total: number,
    filters = "",
    sortType = "",
    page = 0,
    keyword_url = ""
  ): Observable<IProductsPayload> {
    let endpoint = `products/all`;
    if (brand) {
      endpoint = `products/brand/${brand}`;
    }
    let url = "";
    if (trend !== "") {
      url = `${env.API_BASE_HREF}${endpoint}?${trend}=true&limit=${total}&filters=${filters}&sort_type=${sortType}&pageno=${page}`;
    } else {
      url = `${env.API_BASE_HREF}${endpoint}?limit=${total}&filters=${filters}&sort_type=${sortType}&pageno=${page}&keyword_url=${keyword_url}`;
    }
    return this.httpService.get(url);
  }

  getMultiplePageAllProducts(
    trend: string,
    total: number,
    filters = "",
    sortType = "",
    page: number,
    brand: string = ""
  ): Observable<any> {
    const httpCalls = [];
    let endpoint;
    if (brand) {
      endpoint = `products/brand/${brand}`;
    } else {
      endpoint = `products/all`;
    }
    for (let i = 0; i <= page; i++) {
      let url = "";
      if (trend) {
        url = `${env.API_BASE_HREF}${endpoint}?${trend}=true&limit=${total}&filters=${filters}&sort_type=${sortType}&pageno=${i}`;
      } else {
        url = `${env.API_BASE_HREF}${endpoint}?limit=${total}&filters=${filters}&sort_type=${sortType}&pageno=${i}`;
      }

      httpCalls.push(this.httpService.get(url));
    }
    return forkJoin(httpCalls);
  }

  getProducts(
    department: string,
    category: string,
    filters = "",
    sortType = "",
    page = 0,
    isSort: boolean = true
  ): Observable<IProductsPayload> {
    let endpoint;
    if (category == "") {
      endpoint = `products/${department}`;
    } else {
      endpoint =
        department !== ""
          ? `products/${department}/${category}`
          : `products/${category}`;
    }
    let url = "";
    if (isSort) {
      if (endpoint.includes('?')) {
        url = `${env.API_BASE_HREF}${endpoint}&filters=${filters}&sort_type=${sortType}&pageno=${page}`;

      } else {
        url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&pageno=${page}`;
      }
    } else {
      if (endpoint.includes('?')) {
        url = `${env.API_BASE_HREF}${endpoint}&filters=${filters}&pageno=${page}`;

      } else {
        url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&pageno=${page}`;
      }
    }
    // const url= 'https://staging.seededhome.com/api/products/custom/602';
    return this.httpService.get(url);

    // return this.httpService.get('https://staging.seededhome.com/api/products/rugs?filters=&sort_type=recommended&pageno=0');
  }
  getCollectionProducts(
    department: string,
    category: string,
    filters = "",
    sortType = "",
    page = 0
  ): Promise<any> {
    const endpoint = `living-products/${department}/${category}`;
    const url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&pageno=${page}`;
    return this.httpService.get(url).toPromise();
  }
  getFilteredData(
    category: string,
    filters = "",
    sortType = "",
    keyword_url = ""
  ): Observable<Record<string, any>> {
    let endpoint = "";
    let url = "";
    if (category !== "sale" && category !== "new" && category !== "all" && !category.includes('/')) {
      endpoint = `filter-data/all`;
      url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&keyword_url=${category}`;
    } else {
      // if (category.includes("all")) {
      //   let sliced = category.split("/")[1];
      //   if (sliced !== "") {
      //     endpoint = `filter-data/all?${sliced}=true`;
      //     url = `${env.API_BASE_HREF}${endpoint}&filters=${filters}&sort_type=${sortType}&keyword_url=${keyword_url}`;
      //   } else {
      //     endpoint = `filter-data/all?`;
      //     url = `${env.API_BASE_HREF}${endpoint}filters=${filters}&sort_type=${sortType}&keyword_url=${keyword_url}`;
      //   }
      // } else {
      endpoint = `filter-data/${category}`;
      url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&keyword_url=${keyword_url}`;
    }
    // url = `${env.API_BASE_HREF}filter-data/all?filters=&sort_type=&keyword_url=`
    // }
    return this.httpService.get<Record<string, any>>(url);
  }

  getProductFilters(
    category: string,
    filters = "",
    sortType = "",
    keyword_url = "",
    mode =''
  ): Observable<Record<string, any>> {
    let endpoint = "";
    let url = "";
    if (category !== "sale" && category !== "new" && category !== "all" && !category.includes('/')) {
      endpoint = `filter-data/all`;
      url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&keyword_url=${category}&mode=${mode}`;
    } else { 
      endpoint = `filter-data/${category}`;
      url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&keyword_url=${keyword_url}&mode=${mode}`;
    }  
    return this.httpService.get<Record<string, any>>(url);
  }

  getFilterDataByRoomId(roomId: string): Observable<any> {
    const url = `${env.API_BASE_HREF}filter-data/all?filters=room_id:${roomId}`;
    return this.httpService.get(url);
  }

  getFilteredDataForBrand(
    brandName: string,
    category: string,
    filters = "",
    sortType = "",
    keyword_url = ""
  ) {
    let endpoint = "";
    let url = "";
    if (brandName) {
      endpoint = `filter-data/brand/${brandName}`;
      url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&keyword_url=${keyword_url}`;
    } else if (category.includes("all")) {
      let sliced = category.split("/")[1];
      if (sliced !== "") {
        endpoint = `filter-data/all?${sliced}=true`;
        url = `${env.API_BASE_HREF}${endpoint}&filters=${filters}&sort_type=${sortType}&keyword_url=${keyword_url}`;
      } else {
        endpoint = `filter-data/all?`;
        url = `${env.API_BASE_HREF}${endpoint}filters=${filters}&sort_type=${sortType}&keyword_url=${keyword_url}`;
      }
    } else {
      endpoint = `filter-data/${category}`;
      url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&keyword_url=${keyword_url}`;
    }
    return this.httpService.get(url);
  }
  getFilterDataCustom(quizId) {
    const url = `${env.API_BASE_HREF}filter-data/custom/${quizId}`;
    return this.httpService.get(url);
  }
  getBrandData(brandName: string): Observable<any> {
    let endpoint = `brand`;
    if (brandName !== "") {
      endpoint = `brand/${brandName}`;
    }
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  getMultiplePageProducts(
    department: string,
    category: string,
    filters = "",
    sortType = "",
    page: number,
    isSort: boolean = true
  ): Observable<any> {
    const httpCalls = [];
    const endpoint = `products/${department}/${category}`;
    for (let i = 0; i <= page; i++) {
      let url = "";
      if (isSort) {
        url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&sort_type=${sortType}&pageno=${i}`;
      } else {
        url = `${env.API_BASE_HREF}${endpoint}?filters=${filters}&pageno=${i}`;
      }
      httpCalls.push(this.httpService.get(url));
    }
    return forkJoin(httpCalls);
  }

  getProduct(id: string): Observable<any> {
    // id='SOF284T'
    const endpoint = `product/${id}`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
    

  }

  getProductSelection(id: string): Observable<any> {
    const endpoint = `product_selection/${id}`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);

    //     return of({
    //   "selection": [
    //     {
    //       "selections_id": "0",
    //       "selectionsLabel": "Select Color",
    //       "type": "text",
    //       "groupby": null,
    //       "dependence": null,
    //       "requiredSelection": "1",
    //       "options": [
    //         {
    //           "attributeName": "Blue Twill",
    //           "choice_id": 5011282,
    //           "priceGroup": null,
    //           "availabilityGroup": null,
    //           "colorGroup": null,
    //           "eligibility": null,
    //           "availabilityGroupLabel": null,
    //           "colorGroupLabel": null
    //         },
    //         {
    //           "attributeName": "Light Green",
    //           "choice_id": 5011283,
    //           "priceGroup": null,
    //           "availabilityGroup": null,
    //           "colorGroup": null,
    //           "eligibility": null,
    //           "availabilityGroupLabel": null,
    //           "colorGroupLabel": null
    //         },
    //         {
    //           "attributeName": "Cream",
    //           "choice_id": 5011284,
    //           "priceGroup": null,
    //           "availabilityGroup": null,
    //           "colorGroup": null,
    //           "eligibility": null,
    //           "availabilityGroupLabel": null,
    //           "colorGroupLabel": null
    //         },
    //         {
    //           "attributeName": "Dark Gray",
    //           "choice_id": 5011285,
    //           "priceGroup": null,
    //           "availabilityGroup": null,
    //           "colorGroup": null,
    //           "eligibility": null,
    //           "availabilityGroupLabel": null,
    //           "colorGroupLabel": null
    //         }
    //       ]
    //     }
    //   ],
    //   "Pricedetails": [],
    //   "Skudetails": [
    //     {
    //       "selectionChoiceIds": "5011282",
    //       "sku": "70627933",
    //       "name": "Ultra Velvet Upholstered Dining Chairs with High-Back Design and Solid Wood Legs (Set of 2), Blue Twill",
    //       "imagePath": [
    //         "https://s3.us-east-2.amazonaws.com/lazysuzy-images/sellers/way/products/BDIS1436_0_main.jpg"
    //       ],
    //       "price": "430.26",
    //       "was_price": "430.26",
    //       "message": null,
    //       "is_active": "1",
    //       "isShipFree": "0",
    //       "isShipStandard": "0",
    //       "isShipRush": "0",
    //       "isShipDoorstep": "0",
    //       "isShipWhiteGlove": "0",
    //       "isShipFlatRate": "0",
    //       "isShipCPU": "0",
    //       "isShipCustom": "0",
    //       "is_drop": "0",
    //       "is_MTO": "0",
    //       "is_bo_drop": 0,
    //       "bo_date_drop": null,
    //       "is_bo_lz": null,
    //       "bo_date_lz": null,
    //       "shipto_ca": "0",
    //       "is_final": 0
    //     },
    //     {
    //       "selectionChoiceIds": "5011283",
    //       "sku": "54841472",
    //       "name": "Ultra Velvet Upholstered Dining Chairs with High-Back Design and Solid Wood Legs (Set of 2), Light Green",
    //       "imagePath": [
    //         "https://s3.us-east-2.amazonaws.com/lazysuzy-images/sellers/way/products/BDIS1436_0_main.jpg"
    //       ],
    //       "price": "345.33",
    //       "was_price": "345.33",
    //       "message": null,
    //       "is_active": "1",
    //       "isShipFree": "0",
    //       "isShipStandard": "0",
    //       "isShipRush": "0",
    //       "isShipDoorstep": "0",
    //       "isShipWhiteGlove": "0",
    //       "isShipFlatRate": "0",
    //       "isShipCPU": "0",
    //       "isShipCustom": "0",
    //       "is_drop": "0",
    //       "is_MTO": "0",
    //       "is_bo_drop": 0,
    //       "bo_date_drop": null,
    //       "is_bo_lz": null,
    //       "bo_date_lz": null,
    //       "shipto_ca": "0",
    //       "is_final": 0
    //     },
    //     {
    //       "selectionChoiceIds": "5011284",
    //       "sku": "47986836",
    //       "name": "Ultra Velvet Upholstered Dining Chairs with High-Back Design and Solid Wood Legs (Set of 2), Cream",
    //       "imagePath": [
    //         "https://s3.us-east-2.amazonaws.com/lazysuzy-images/sellers/way/products/BDIS1436_0_main.jpg"
    //       ],
    //       "price": "382.85",
    //       "was_price": "382.85",
    //       "message": null,
    //       "is_active": "1",
    //       "isShipFree": "0",
    //       "isShipStandard": "0",
    //       "isShipRush": "0",
    //       "isShipDoorstep": "0",
    //       "isShipWhiteGlove": "0",
    //       "isShipFlatRate": "0",
    //       "isShipCPU": "0",
    //       "isShipCustom": "0",
    //       "is_drop": "0",
    //       "is_MTO": "0",
    //       "is_bo_drop": 0,
    //       "bo_date_drop": null,
    //       "is_bo_lz": null,
    //       "bo_date_lz": null,
    //       "shipto_ca": "0",
    //       "is_final": 0
    //     },
    //     {
    //       "selectionChoiceIds": "5011285",
    //       "sku": "47986835",
    //       "name": "Ultra Velvet Upholstered Dining Chairs with High-Back Design and Solid Wood Legs (Set of 2), Dark Gray",
    //       "imagePath": [
    //         "https://s3.us-east-2.amazonaws.com/lazysuzy-images/sellers/way/products/BDIS1436_0_main.jpg"
    //       ],
    //       "price": "392.83",
    //       "was_price": "392.83",
    //       "message": null,
    //       "is_active": "1",
    //       "isShipFree": "0",
    //       "isShipStandard": "0",
    //       "isShipRush": "0",
    //       "isShipDoorstep": "0",
    //       "isShipWhiteGlove": "0",
    //       "isShipFlatRate": "0",
    //       "isShipCPU": "0",
    //       "isShipCustom": "0",
    //       "is_drop": "0",
    //       "is_MTO": "0",
    //       "is_bo_drop": 0,
    //       "bo_date_drop": null,
    //       "is_bo_lz": null,
    //       "bo_date_lz": null,
    //       "shipto_ca": "0",
    //       "is_final": 0
    //     }
    //   ]
    // })
  }

  getAllBrandNames(): Observable<any> {
    const endpoint = `brand`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  getAllDepartments(brandFilter: string = ""): Observable<IDepartment> {
    let endpoint = `all-departments-v1`;
    if (brandFilter !== "" && brandFilter !== undefined) {
      endpoint = `all-departments-v1?brands=${brandFilter}`;
    }
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  getBrowseTabData(
    id: string,
    appliedFilters: string,
    pageNo
  ): Observable<any> {
    const endpoint = `products/all`;
    const url = `${env.API_BASE_HREF
      }${endpoint}?filters=${appliedFilters};category:${id}&sort_type=&pageno=${pageNo || 0
      }&limit=24&board-view=true`;
    return this.httpService.get(url);
  }

  getSearchProducts(
    search: string,
    pageNo: number
  ): Observable<ISearchProductsPayload> {
    const endpoint = `products/_search`;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    // const url = `${env.ES_API_BASE_HREF}${endpoint}?source=${searchQuery}&source_content_type=application%2Fjson`;
    const url = `${env.API_BASE_HREF}search-keywords?q=${search}&page=${pageNo}`;
    return this.httpService.get(url, headers);
  }

  getWishlistProducts(isBoard): Observable<IProductsPayload> {
    const endpoint = `wishlist`;
    const url = `${env.API_BASE_HREF}${endpoint}${isBoard ? "?board-view=true" : ""
      }`;
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.cookie.get("token")}`,
    });
    return this.httpService.get(url, headers);
  }

  getCategories(department: string): Observable<ISearchProductsPayload> {
    const endpoint = department ? `categories/${department}` : `categories`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  getCategroyList() {
    const endpoint = `get_categorylist`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  login(data) {
    const endpoint = `login`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.cookie.get("token")}`,
    });
    return this.httpService.post(url, data, headers);
  }

  subscription(URL, email): Observable<string> {
    const endpoint = `subscribe`;
    const url = `${env.API_BASE_HREF}${endpoint}?url=${URL}&email=${email}`;
    return this.httpService.get(url);
  }
    onlySubscription(): Observable<string> {
    const endpoint = `createpromo`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }
  newsLetterSubmit(email): Observable<string> {
    const endpoint = `createpromo?type=NewSub`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, {});
  }

  wishlistProduct(sku, mark, isHandset: boolean) {
    let endpoint;
    if (mark) {
      endpoint = `mark/favourite/${sku}`;
    } else {
      endpoint = `unmark/favourite/${sku}`;
    }
    const token = this.cookie.get("token");
    // if (!token) {
    //     // trigger signup window
    //     this.utils.openSignupDialog(isHandset, true);
    //     return;
    // }
    const url = `${env.API_BASE_HREF}${endpoint}`;

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    return this.httpService.get(url, headers);
  }

  signup(data) {
    const endpoint = `register`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.cookie.get("token")}`,
    });
    return this.httpService.post(url, data, headers);
  }

  signout() {
    const endpoint = `logout`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.cookie.get("token")}`,
    });
    return this.httpService.get(url, headers);
  }

  keepAlive() {
    const endpoint = `user/keepalive`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.cookie.get("token")}`,
    });
    return this.httpService.get(url, headers);
  }

  getPosts(): Observable<any[]> {
    return this.httpService.get<any[]>(
      "https://psimonmyway.com/wp-json/wp/v2/posts?_embed",
      {
        params: {
          per_page: "6",
        },
      }
    );
  }

  getPostById(id): Observable<any[]> {
    return this.httpService.get<any[]>(
      `https://psimonmyway.com/wp-json/wp/v2/posts/${id}`
    );
  }

  getAuthToken(accessToken, provider) {
    const endpoint = `oauth/token`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    const data = {
      access_token: accessToken,
      client_id: env.CLIENT_ID,
      client_secret: env.CLIENT_SECRET,
      grant_type: "social",
      provider,
    };
    return this.httpService.post(url, data);
  }

  searchCustomer(user_id: string) {
    // user_id='4103'
    const url = `${env.API_BASE_HREF}get_addressbook?user_id=${user_id}`;
    return this.httpService.get(url);
  }

  saveAddressBook(data: any) {
    const url = `${env.API_BASE_HREF}save_addressbook`;
    return this.httpService.post(url, data);
  }

  addCartProduct(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    // if(!data['cart_id']) { data['cart_id']=''}
    const endpoint = "cart/add";
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  addDesignCartProduct(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    // if(!data['cart_id']) { data['cart_id']=''}
    const endpoint = "design_product_add";
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  removeDesignCartProduct(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    // if(!data['cart_id']) { data['cart_id']=''}
    const endpoint = "design_product_remove";
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }


  removeCartProduct(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const endpoint = "cart/remove";
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }


  cartProductApproval(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const endpoint = "cart/approval";
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  designProductApproval(data) {
    const endpoint = "design_product_approve";
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data);
  }

  designProductReject(data) {
    const endpoint = "design_product_reject";
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data);
  }

getCartProduct(hasState, state, hasPromo?, promoCode?, walletCode = '') {

  const token = this.cookie.get("token");

  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  });

  let endpoint = "cart";
  let query = [];

  if (hasState) query.push(`state_code=${state}`);
  if (hasPromo && promoCode) query.push(`promo=${promoCode}`);
  if (walletCode) query.push(`wallet_code=${walletCode}`);

  const url = `${env.API_BASE_HREF}${endpoint}${query.length ? "?" + query.join("&") : ""}`;

  return this.httpService.get(url, headers );
}

  getCartProductsFromDashboard(roomId) {
    let endpoint = `cart_servicerep?room_id=${roomId}`
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url, headers);
  }
getCartShippingTest(userID) {

  let endpoint = `cart_preview?user_id=${userID}`
    // const token = this.cookie.get("token");
    // const headers = new HttpHeaders({
    //   "Content-Type": "application/json",
    //   Authorization: `Bearer ${token}`,
    // });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }
  

  getAllDepartmentsBoard(): Observable<IDepartment> {
    const endpoint = `all-departments-v1`;
    const url = `${env.API_BASE_HREF}${endpoint}?board-view=true`;
    return this.httpService.get(url);
  }

  getAllBoards(payload): Observable<IProductPayload> {
    const url = `${env.API_BASE_HREF}board`;
    return this.httpService.post(url, {
      operation: "select",
      entity: "board",
      data: 5,
      Buser_id: 1,
    });
  }

  createOrder(data) {
    const url = `${env.API_BASE_HREF}create_order`;
    return this.httpService.post(url, data);
  }

  captureOrder(data) {
    const url = `${env.API_BASE_HREF}paypal_capture_order`;
    return this.httpService.post(url, data);
  }

  paymentCharge(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const endpoint = `payment_charge`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  paymentChargeBooking(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const endpoint = `design_payment_charge`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  getOrderSuccessData(orderId) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const endpoint = `order?order_id=${orderId}`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url, headers);
  }

  userUpdate(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const endpoint = `user/update`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  sendPasswordResetLink(data) {
    const endpoint = `password/create`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data);
  }

  validateResetPasswordToken(token) {
    const endpoint = `password/find/${token}`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  setNewPassword(data) {
    const endpoint = `password/reset`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data);
  }

  updateProfile(data) {
    const endpoint = "user/details/update";
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  getProfile() {
    const endpoint = "get-user";
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url, headers);
  }

  fetchDisplayProfile(username) {
    const endpoint = `user/details?username=${username}`;
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url, headers);
  }

  getUserBoards(username) {
    const endpoint = `board?username=${username}`;
    const token = this.cookie.get("token");
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  likeBoard(boardId, like) {
    const apiAction = like ? "like" : "unlike";
    const endpoint = `board/${apiAction}/${boardId}`;
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, headers);
  }

  getCollections() {
    const url = `${env.API_BASE_HREF}collections`;
    return this.httpService.get(url);
  }

  getCollectionData(collection) {
    const url = `${env.API_BASE_HREF}collection?collection=${collection}`;
    return this.httpService.get(url);
  }

  getDeals() {
    const url = `${env.API_BASE_HREF}deals`;
    return this.httpService.get(url);
  }

  getRecentProducts() {
    const recentProductsUrl = `sku-history`;
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${recentProductsUrl}`;
    return this.httpService.get(url, headers);
  }

  submitReview(data) {
    const endpoint = "review";
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  getProductReviews(id: string, limit) {
    // const limit = 6;
    const endpoint = `review/getreview-${id}/${limit}`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  // Mark Review Helpful
  markReviewHelpful(userId: number, reviewId: number) {
    const data = {
      user_id: userId,
      review_id: reviewId,
    };
    const endpoint = `mark-helpful`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data);
  }

  // Report Review
  reportReview(userId: number, reviewId: number) {
    const data = {
      user_id: userId,
      review_id: reviewId,
    };
    const endpoint = `mark-reported`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data);
  }

  // Get Full Review List
  getFullReviewList(sku, pageNo, sortType: string = "") {
    const endpoint = sortType
      ? `allreviews/${sku}?sort_type=${sortType}&pageno=${pageNo}`
      : `allreviews/${sku}?pageno=${pageNo}`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.get(url);
  }

  // getOtherPeopleProducts()
  getOtherPeopleProducts(sku) {
    const endPoint = `other-views/userrelated-${sku}`;
    const url = `${env.API_BASE_HREF}${endPoint}`;
    return this.httpService.get(url);
  }

  // Api to get Order Details
  getOrderDetails(orderNumber, zipCode) {
    const endPoint =
      orderNumber && zipCode
        ? `order_status?orderid=${orderNumber}&zipcode=${zipCode}`
        : `order_status`;
    const url = `${env.API_BASE_HREF}${endPoint}`;
    return this.httpService.get(url);
  }

  saveCheckoutEmail(emailId = "") {
    if (emailId) {
      const endpoint = "save_checkout";
      const token = this.cookie.get("token");
      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
      const data = {
        emailid: emailId,
      };
      const url = `${env.API_BASE_HREF}${endpoint}`;
      return this.httpService.post(url, data, headers);
    }
  }

  getCollectionsCount() {
    const endPoint = "get_all_collection";
    const url = `${env.API_BASE_HREF}${endPoint}`;
    return this.httpService.get(url);
  }

  getProductShippingStatus(zipcode, productSku, site: string): Promise<any> {
    const token = this.cookie.get("token");
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    let zipCodeCheckUrl = "";
    if (site === "westelm") {
      headers = new HttpHeaders({
        Accept: "application/json",
        "Accept-Encoding": "gzip, deflate",
        Authorization: `Bearer ${token}`,
      });
      zipCodeCheckUrl = `${env.API_BASE_HREF}scraper/westelm`;
    } else if (site === "cb2") {
      zipCodeCheckUrl = `${env.API_BASE_HREF}scraper/cb2`;
    } else if (site == "cab") {
      zipCodeCheckUrl = `${env.API_BASE_HREF}scraper/cnb`;
    } else {
      zipCodeCheckUrl = `${env.API_BASE_HREF}get_shipzip_status`;
    }
    const url = `${zipCodeCheckUrl}?sku=${productSku}&zipcode=${zipcode}`;;
    return this.httpService.get(url, headers).toPromise();
  }

  getTestimonials(filter = null) {
    const endPoint = filter ? `testimonials${filter}` : "testimonials?sortby=serial&sorttype=asc";
    const url = `${env.API_BASE_HREF}${endPoint}`;
    return this.httpService.get(url);
  }
  getDesignTestimonials() {
    const endPoint = "testimonials?type=design&sortby=serial&sorttype=asc";
    const url = `${env.API_BASE_HREF}${endPoint}`;
    return this.httpService.get(url);
  }
  getShipzipStatus(zipcode, productSku) {
    const url = `${env.API_BASE_HREF}get_shipzip_status?sku=${productSku}&zipcode=${zipcode}`;
    return this.httpService.get(url);
  }
  getProductFinder(pageNo: number) {
    const url = `${env.API_BASE_HREF}product_finder/${pageNo}`;
    return this.httpService.get(url);
  }
  getSizingData(data: any) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}size_range_finder`;
    return this.httpService.post(url, data, headers);
  }
  getPricingData(data: any) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}price_range_finder`;
    return this.httpService.post(url, data, headers);
  }
  getShapeData(data: any) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}shape_finder`;
    return this.httpService.post(url, data, headers);
  }
  getQuizResLeftPanel(id: string) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const data = { ls_id: id };
    const url = `${env.API_BASE_HREF}left_panel`;
    return this.httpService.post(url, data, headers);
  }
  searchProductFinder(data: any): Promise<any> {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}search_finder`;
    return this.httpService.post(url, data, headers).toPromise();
  }
  searchProductFinderCollection(data: any): Promise<any> {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}search_finder_collection`;
    return this.httpService.post(url, data, headers).toPromise();
  }

  saveQuizData(data: any): Observable<any> {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}save_quiz_sofa`;
    return this.httpService.post(url, data, headers);
  }
  getWareHouseLocations(productSku) {
    const url = `${env.API_BASE_HREF}warehouse_locations?productid=${productSku}`;
    return this.httpService.get(url);
  }
  saveEmailTemplateSchedule(data: any): Observable<any> {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}newsletter_mailer`;
    return this.httpService.post(url, data, headers);
  }
  getEmailTemplateSchedule(): Observable<any> {
    const url = `${env.API_BASE_HREF}get_email_data`;
    return this.httpService.get(url);
  }
  getAllDesignBookings(status, designer, timePeriod,page,archived) {
    // &pageno=${(+page)>0 ? page:''}
    const url = `${env.API_BASE_HREF}alldesignbooking?status=${status}&designerid=${designer}&timePeriod=${timePeriod}&archived=${archived}`;
    return this.httpService.get(url);
  }
    getAllDesignBookingsByStatusEmail(status, designer,page) {
    const url = `${env.API_BASE_HREF}alldesignbooking?status=${status}&email=${designer}&pageno=${page}`;
    return this.httpService.get(url);
  }
  getPickupLogs(sortBy, sortType, filter: string) {
    const url = `${env.API_BASE_HREF}pickup_log?sortby=${sortBy}&sorttype=${sortType}&filters=${filter}`;
    return this.httpService.get(url);
  }
  getOrderCourier() {
    const url = `${env.API_BASE_HREF}get_order_courier`;
    return this.httpService.get(url);
  }

  sendDesignBookingMail(data) {
    const url = `${env.API_BASE_HREF}designbookingmail`;
    return this.httpService.post(url, data);
  }

  cancelEmailTemplateSchedule(id: any): Observable<any> {
    const url = `${env.API_BASE_HREF}cancel_batch`;
    return this.httpService.post(url, { id: id });
  }
  getProdImgBoard(sku: string): Observable<any> {
    const url = `${env.API_BASE_HREF}product_imageBoard/${sku}`;
    return this.httpService.get(url);
  }
  getDesignProject(id) {
    const url = `${env.API_BASE_HREF}get_designProject?room_id=${id}`;
    return this.httpService.get(url);
  }
  getDesignImages(id) {
    const url = `${env.API_BASE_HREF}getdesign_image?room_id=${id}`;
    return this.httpService.get(url);
  }
  paintSearch(q:string,limit:number=25){
   
   const  url = `${env.API_BASE_HREF}paint/search?q=${q}&limit=${limit}`;
   
    return this.httpService.get(url);
  }
  getPaintApplications(){
    const url = `${env.API_BASE_HREF}paint/applications`;
    return this.httpService.get(url); 
  }
  getPaintFinishes(){
        const url = `${env.API_BASE_HREF}paint/finishes`;
    return this.httpService.get(url); 
  }
  savePaint(payload:any){
      const url = `${env.API_BASE_HREF}room/paint-recommendation/save`;
    return this.httpService.post(url, payload);
  }
  updatePaintRecommendation(payload:any){
      const url = `${env.API_BASE_HREF}room/paint-recommendation/update`;
    return this.httpService.post(url, payload);
  }
  paintRecStatusUpdate(payload:any){
          const url = `${env.API_BASE_HREF}room/paint-recommendation/status`;
    return this.httpService.post(url, payload);
  }
  getPaintRecommendations(roomId:string){
       const url = `${env.API_BASE_HREF}room/paint-recommendations?room_id=${roomId}`;
    return this.httpService.get(url); 
  }
  removeImg(payload) {
    const url = `${env.API_BASE_HREF}updateimage_status`;
    return this.httpService.post(url, payload);
  }
  cancelAppointment(id: any): Observable<any> {
    const url = `${env.API_BASE_HREF}cancelappoinment`;
    return this.httpService.post(url, { id: id });
  }
  tradeDashboard(hasFilter): Observable<any> {
    let url = "";
    if (hasFilter) {
      url = `${env.API_BASE_HREF}tradeDashboard?${hasFilter}`;
    } else {
      url = `${env.API_BASE_HREF}tradeDashboard`;
    }
    return this.httpService.get(url);
  }
  getInvoiceDates(): Observable<any> {
    const url = `${env.API_BASE_HREF}optionsInvoiceDate`;
    return this.httpService.get(url);
  }
  getOptionsAssignedTo(): Observable<any> {
    const url = `${env.API_BASE_HREF}optionsAssignedTo`;
    return this.httpService.get(url);
  }
  getTradeStatus(): Observable<any> {
    const url = `${env.API_BASE_HREF}tradeStatus`;
    return this.httpService.get(url);
  }
  save_keyword() {
    const url = `${env.API_BASE_HREF}save_keyword`;
    return this.httpService.post(url, {});
  }
  savePackaging(data: any) {
    const url = `${env.API_BASE_HREF}save_packaging`;
    return this.httpService.post(url, data);
  }
  getPackaging(sku) {
    const url = `${env.API_BASE_HREF}get_packaging/${sku}`;
    return this.httpService.get(url);
  }
  saveRoomDesign(data: FormData) {
    const endpoint = `save_roomdesign`;
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }
  getEditPrdFilter() {
    const url = `${env.ADMIN_API_BASE_HREF}edit-products-filter`;
    return this.httpService.get(url);
  }
  postPaymentOnServer(data: any) {
    const endpoint = `gpt_payment`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data);
  }
  getAvailableCredits() {
    const url = `${env.API_BASE_HREF}get_user_credits`;
    return this.httpService.get(url);
  }
  userLikeUnlike(data: any) {
    const url = `${env.API_BASE_HREF}gpt_rendering_like`;
    return this.httpService.post(url, data);
  }

  getNewProductsListing(
    page: number,
    brand: string[],
    product_categories: string[],
    vendor_category: string[],
    status: string[], 
    sortBy: string,
    sortType: string
  ) {
    const brandFilter = brand?.toString();
    const vendorCategoryFilter = vendor_category?.toString();
    const productCategoryFilter = product_categories?.toString();
    const statusFilter = status?.toString(); 
    const filters: string[] = [];
 
    if (brandFilter) filters.push(`brand:${brandFilter}`);
    if (statusFilter) filters.push(`status:${statusFilter}`);
    if (productCategoryFilter) filters.push(`product_category:${productCategoryFilter}`);
    if (vendorCategoryFilter) filters.push(`category_id:${vendorCategoryFilter}`);

    let url = `${env.ADMIN_API_BASE_HREF}new-products-listing?`;
      if (filters.length) {
      url += `filters=${filters.join(";")};&`;
    }
    // if (sortBy && sortType) {
      url += `sortby=${sortBy ? sortBy : 'created_date'}&sorttype=${sortType ? sortType : 'desc'}&`;
    // }
  
    url += `pageno=${page}`;
    return this.httpService.get(url);
  }
  getAllProductsListing(
    page: number,
    filters: string,
    sortBy: string,
    sortType: string
  ) {
    let url = ''
    if (sortBy && sortType) {
      url = `${env.ADMIN_API_BASE_HREF}products-listing?sortby=${sortBy}&sorttype=${sortType}&filters=${filters}&pageno=${page}`;

    } else {
      url = `${env.ADMIN_API_BASE_HREF}products-listing?&filters=${filters}&pageno=${page}`;
    }
    return this.httpService.get(url);
  }
  updateStatusProductsListing(data: any) {
    const url = `${env.ADMIN_API_BASE_HREF}new-products/update-status`;
    return this.httpService.post(url, data);
  }

  getAllBrandList() {
    const url = `${env.API_BASE_HREF}brand_new`;
    return this.httpService.get(url);
  }

  getAllCategoryList() {
    const url = `${env.API_BASE_HREF}departments_new`;
    return this.httpService.get(url);
  }
  getPredictionProducts(data, filters: string, pageNo) {
    let tailUrl = `room=${data.room}&class=${data.class}`;
    // if (data.color) {
    //   tailUrl = `${tailUrl}&color=${data.color}`;
    // }
    // if (data.shape) {
    //   tailUrl = `${tailUrl}&shape=${data.shape}`;
    // }
    const url = `${env.API_BASE_HREF}get_class_products?${tailUrl}&filters=${filters}&pageno=${pageNo}`;
    // const url = 'https://staging.seededhome.com/api/get_class_products?room=livingroom&class=side%20table&color=&shape=&style=midcentury&pageno=0';
    return this.httpService.get(url);
  }
  getFilteredProducts(data, filters) {
    let tailUrl = `room=${data.room}&class=${data.class}`;
    const url = `${env.API_BASE_HREF}filter-data?${tailUrl}&filters=${filters}&sort_type=recommended`;
    // const url = `${env.API_BASE_HREF}filter-data?room=livingroom&class=side%20table&filters=style:midcentury;color:white;shape:round;&sort_type=recommended`;
    return this.httpService.get(url);
  }
  getImageClassification(img) {
    const url = `${env.API_BASE_HREF}get_imageclassification?image=${img}`;
    return this.httpService.get(url);
  }
  getImageRetrive(img) {
    const url = `${env.API_BASE_HREF}get_imageretrieval?image=${img}`;
    return this.httpService.get(url);
  }
  getGptRenderings(pageNo) {
    const url = `${env.API_BASE_HREF}get_renderimagelist?sortby=likes&sorttype=asc&pageno=${pageNo}`;
    return this.httpService.get(url);
  }
  getGptRendersByUser(pageNo) {
    const url = `${env.API_BASE_HREF}get_renderimagelist_byuser?pageno=${pageNo}`;
    return this.httpService.get(url);
  }
  getPinBoardList(img_id, user_id) {
    const url = `${env.API_BASE_HREF}get_pinboardlist?image_id=${img_id}&user_id=${user_id}`;
    return this.httpService.get(url);
  }
  savePinBoard(data) {
    const url = `${env.API_BASE_HREF}save_pinboard`;
    return this.httpService.post(url, data);
  }
  insertCredits() {
    const url = `${env.API_BASE_HREF}insert_user_credit`;
    return this.httpService.post(url, {});
  }
  getGenomeData() {
    const url = `${env.API_BASE_HREF}genomeslist`;
    return this.httpService.get(url);
    // return this.httpService.get('/assets/genome_list.json');
  }
  saveQuizViewedGenomes(data) {
    const url = `${env.API_BASE_HREF}quiz_viewed_genomes`;
    return this.httpService.post(url, data);
  }
  saveQuizSelectedGenomes(data) {
    const url = `${env.API_BASE_HREF}quiz_selected_genomes`;
    return this.httpService.post(url, data);
  }
  createStyleQuiz(data) {
    const url = `${env.API_BASE_HREF}create_style_quiz`;
    return this.httpService.post(url, data);
  }
  getStyleReport(quiz_id: any) {
    // https://staging.seededhome.com/api/style_report/{quiz_id}
    const url = `${env.API_BASE_HREF}style_report?quiz_id=${quiz_id}`;
    return this.httpService.get(url);
  }

  getQuizCategories() {
    const url = `${env.API_BASE_HREF}quiz_categories`;
    return this.httpService.get(url);
  }
  updateAssignedDesigner(data: any) {
    const url = `${env.API_BASE_HREF}update_assigned_designer`;
    return this.httpService.post(url, data);
  }
  getStyleProductList(quizId) {
    // quizId='895'
    const url = `${env.API_BASE_HREF}style_productlist/${quizId}`;
    return this.httpService.get(url);
  }
  saveQuizSelectedProducts(data) {
    const url = `${env.API_BASE_HREF}quiz_selected_products`;
    return this.httpService.post(url, data);
  }
  saveQuizLifestyle(data) {
    const url = `${env.API_BASE_HREF}quiz_lifestyle`;
    return this.httpService.post(url, data);
  }
  updateQuizUser(quizId) {
    const url = `${env.API_BASE_HREF}update_quizuser`;
    return this.httpService.post(url, { quiz_id: quizId });
  }
  saveQuizMail(data) {
    const url = `${env.API_BASE_HREF}register_auto`;
    return this.httpService.post(url, data);
  }
  saveDesignBookings(data) {
    const url = `${env.API_BASE_HREF}design_bookings`;
    return this.httpService.post(url, data);
  }
  sendMailDesigner(roomId: any) {

    const url = `${env.API_BASE_HREF}mail_designer_room_assignment`;
    return this.httpService.post(url, { room_id: roomId });

  }
  mailDesignerOrderAss(roomId: any) {
    const url = `${env.API_BASE_HREF}mail_designer_order_assignment`;
    return this.httpService.post(url, { room_id: roomId });
  }
  updateDesignBookings(data) {
    const url = `${env.API_BASE_HREF}update_design_bookings`;
    return this.httpService.post(url, data);
  }
  designPayment() {
    const url = `${env.API_BASE_HREF}design_payment`;
    return this.httpService.post(url, {});
  }
  customerCreate(data: any) {
    const url = `${env.API_BASE_HREF}design_customer_create`;
    return this.httpService.post(url, data);
  }

  stripeDesignPayment(data = {}) {
    const url = `${env.API_BASE_HREF}design_payment_stripe`;
    return this.httpService.post(url, data);
  }

  stripeCustomerCreate(data: any) {
    const url = `${env.API_BASE_HREF}design_customer_create_stripe`;
    return this.httpService.post(url, data);
  }

  getProductPageTitle(quizId) {
    const url = `${env.API_BASE_HREF}name/${quizId}`;
    return this.httpService.get(url);
  }
  savePageTitle(data) {
    const url = `${env.API_BASE_HREF}/udpate-name`;
    return this.httpService.post(url, data);
  }
  getProjectIntakeDropdowns() {
    const url = `${env.API_BASE_HREF}design_intake_dropdown`;
    return this.httpService.get(url);
  }
  saveDesignIntake(data) {
    const url = `${env.API_BASE_HREF}savedesign_intake`;
    return this.httpService.post(url, data);
  }
    saveDesignHomeProfile(data) {
    const url = `${env.API_BASE_HREF}design_home_profile`;
    return this.httpService.post(url, data);
  }

  updateDesignCheckout(data) {
    const url = `${env.API_BASE_HREF}update_design_checkout`;
    return this.httpService.post(url, data);
  }

  
  saveDesignImages(data) {
    const url = `${env.API_BASE_HREF}savedesign_image`;
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.httpService.post(url, data, headers);
  }
  saveDesignDeliverables(data) {
    const url = `${env.API_BASE_HREF}savedesign_deliverables`;
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.httpService.post(url, data, headers);
  }

  updateDesignDeliverables(data) {
    const url = `${env.API_BASE_HREF}update_deliverables`;
    // const token = this.cookie.get("token");
    // const headers = new HttpHeaders({
    //   Authorization: `Bearer ${token}`,
    // });
    return this.httpService.post(url, data);
  }
  publisDesignDeliverables(data) {
    const url = `${env.API_BASE_HREF}publish_deliverables`;
    return this.httpService.post(url, data);
  }

  designGallerySpotlight() {
    const url = `${env.API_BASE_HREF}design_gallery_spotlight`;
    return this.httpService.get(url);
  }

  designStyleProfile(data) {
    const url = `${env.API_BASE_HREF}design_style_profile`;
    return this.httpService.post(url, data);
  }

  getDesignIntake(roomId) {
    const url = `${env.API_BASE_HREF}design_intake?room_id=${roomId}`;
    return this.httpService.get(url);
  }

  getUserProfiles(){
       const url = `${env.API_BASE_HREF}get_user_profiles`;
    return this.httpService.get(url);
  }

  removeDesignHomeProfile(data){
        const url = `${env.API_BASE_HREF}remove_design_home_profile`;
    return this.httpService.post(url, data);
  }
  getImageBlob(url: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Failed to fetch image (status ${response.status})`);
          }
          return response.blob();
        })
        .then(blob => resolve(blob))
        .catch(error => reject(error));
    });
  }
  getProjectDropdown() {
    const url = `${env.API_BASE_HREF}design_project_list?designstatus=02,03,09`;
    return this.httpService.get(url);
  }

  updateBookingTask(data) {
    const url = `${env.API_BASE_HREF}update_bookingtask`;
    return this.httpService.post(url, data);
  }


  addRoomToOrder(data) {
    const url = `${env.API_BASE_HREF}add_order_to_room`;
    return this.httpService.post(url, data);
  }
  getDesignStausList() {
    const url = `${env.API_BASE_HREF}get_design_codes`;
    return this.httpService.get(url);
  }
  getRoomCodes() {
    const url = `${env.API_BASE_HREF}get_room_codes`;
    return this.httpService.get(url);
  }

  updateDesignStatus(data) {
    const url = `${env.API_BASE_HREF}save_designStatus`;
    return this.httpService.post(url, data);
  }
  removeProduct(data) {
    const url = `${env.API_BASE_HREF}design_product_remove`;
    return this.httpService.post(url, data);
  }

  designProductAlternate(data) {
    const url = `${env.API_BASE_HREF}design_product_alternate`;
    return this.httpService.post(url, data);
  }

  designProductFeatured(data) {
    const url = `${env.API_BASE_HREF}design_product_feature`;
    return this.httpService.post(url, data);
  }

  designProductShare(data) {
    const url = `${env.API_BASE_HREF}design_product_share`;
    return this.httpService.post(url, data);
  }

  mailDesignCatalogUser(data) {
    const url = `${env.API_BASE_HREF}mail_design_catalog_user`;
    return this.httpService.post(url, data);
  }
  updateDesignCatalog(data) {
    const url = `${env.API_BASE_HREF}update_design_catalog`;
    return this.httpService.post(url, data);
  }

  getLandingDesignImages() {
    const url = `${env.API_BASE_HREF}designImages`;
    return this.httpService.get(url);
  }

  aiSubscribe(email: string) {
    const url = `${env.API_BASE_HREF}subscribe?url=AI&email=${email}`;
    return this.httpService.get(url);
  }

  pdpSubscribe(email: string) {
    const url = `${env.API_BASE_HREF}subscribe?url=PDP_banner&email=${email}`;
    return this.httpService.get(url);
  }
  getImgComparison() {
    const url = `${env.API_BASE_HREF}design_gallery`;
    return this.httpService.get(url);
  }
  updateProductPosition(data) {
    const url = `${env.API_BASE_HREF}update_product_position`;
    return this.httpService.post(url, data);
  }

  addDesignCatalog(data:any) {
    const url = `${env.API_BASE_HREF}add_design_catalog`;
    return this.httpService.post(url, data);
  }

  getDiscountData() {
    const url = `${env.API_BASE_HREF}get_design_pricing`;
    return this.httpService.get(url);
  }

  createPromo() {
    const url = `${env.API_BASE_HREF}createpromo?type=NewSub`;
    return this.httpService.post(url, {});
  }

  applyPromoCode(data) { 
    const url = `${env.API_BASE_HREF}code/apply`;
    return this.httpService.post(url, data);
//     return of({
//   "success": true,
//   "message": "Wallet code already redeemed and active on your account.",
//   "balance_cents": 147000,
//   "cart": {
//     "user": {
//       "emailid": "sriram@seededhome.com"
//     },
//     "products": [
//       {
//         "product_sku": "ALF9690-53SQ",
//         "image": "https://s3.us-east-2.amazonaws.com/lazysuzy-images/sellers/liv/products/ALF9690-251110_0_main.jpg",
//         "pname": null,
//         "count": 1,
//         "ship_code": "F0",
//         "ship_custom": 0,
//         "max_available_count": 1000,
//         "price": "147.00",
//         "was_price": "200.00",
//         "shipto_ca": "0",
//         "is_virtual": "0",
//         "is_approved": 0,
//         "label": "Free shipping",
//         "parent_sku": "ALF-9690",
//         "parent_name": "Alfresco Machine Woven Rug",
//         "product_name": "Alfresco Machine Woven Rug",
//         "reviews": null,
//         "rating": null,
//         "product_description": "Make your outdoor space more inviting and comfortable with the Alfresco Area Rug. Made of durable Polypropylene, this machine-woven rug is designed to withstand all kinds of weather and high traffic areas. It features a beautiful style that will look great in any space and no pile for easy maintenance. Plus, it's outdoor safe so you can use it on your patio or porch without worry. To make sure your rug lasts longer, we recommend using a rug pad (sold separately). When cleaning, simply hose off with water and hang to dry.",
//         "site": "liv",
//         "brand_id": "liv",
//         "brand": "liv",
//         "brand_name": "Livabliss",
//         "mfg_country": "Egypt",
//         "product_status": "active",
//         "inventory": {
//           "in_inventory": true,
//           "inventory_product_details": {
//             "price": "147.00",
//             "was_price": "200.00",
//             "count": 1000,
//             "message": null,
//             "is_low": false,
//             "is_mto": "0",
//             "is_final": 0,
//             "is_drop": "0",
//             "is_bo_drop": 0,
//             "bo_date_drop": null,
//             "is_bo_lz": null,
//             "bo_date_lz": null,
//             "mto_process_time": null,
//             "shipto_ca": "0",
//             "design_price": null
//           }
//         },
//         "discount": "26.50",
//         "total_price": 147,
//         "total_was_price": 200,
//         "product_ship_cost": 0
//       }
//     ],
//     "order": {
//       "sub_total": 147,
//       "total_cost": 0,
//       "shipment_total": 0,
//       "sales_tax_total": 0,
//       "order_ship_cost": 0,
//       "total_promo_discount": 0,
//       "original_total_cost": 147,
//       "original_sub_total": 147,
//       "wallet_credit_available": 147,
//       "wallet_used": 147,
//       "wallet_remaining": 0
//     },
//     "auth": true,
//     "auth_id": 4337
//   },
//   "type": "wallet"
// })
  }
  

  senMailShoppinglist(data) {
    const url = `${env.API_BASE_HREF}mail_shopping_list`;
    return this.httpService.post(url, data);
  }

  getShoppingTemplatelist() {
    const url = `${env.API_BASE_HREF}shopping_template_list`;
    return this.httpService.get(url);
  }

  getEmailFlags() {
    const url = `${env.API_BASE_HREF}email_flag_list`;
    return this.httpService.get(url);
  }

  getPartnersList() {
    const url = `${env.API_BASE_HREF}partner_list`;
    return this.httpService.get(url);
  }

  getPromoCodeStatus(userId) {
    const url = `${env.API_BASE_HREF}promo-code-status?assigned_to=${userId}`;
    return this.httpService.get(url);
  }


  postStripeToken(data) {
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const endpoint = `payment/charge`;
    const url = `${env.API_BASE_HREF}${endpoint}`;
    return this.httpService.post(url, data, headers);
  }

  getRoomValue(room: string): string {
    let val = room === 'living' ? 'Living Room' :
      room === 'dining' ? 'Dining Room' :
      room === 'bedroom' ? 'Bedroom' :
      room === 'office' ? 'Home Office' :
      room === 'kids' ? 'Kids Room / Nursery' :
      room === 'bath' ? 'Bathroom' :
      room === 'kitchen' ? 'Kitchen' :
      room === 'game' ? 'Game Room' :
      room === 'outdoor' ? 'Outdoor' :
      room === 'entry' ? 'Entryway' :
      room;
    return val;
  }
 getDeliveryValue(delivery: string): { text: string; color: string } {
  const deliverySpeedColorMap: Record<string, string> = {
    no_rush: '#5F8F74',
    soonish: '#C48A3A',
    asap: '#C65A5A',
  };

  if (typeof delivery !== 'string' || !delivery.trim()) {
    return { text: '', color: '#000' };
  }

  const normalized = delivery.toLowerCase();

  return {
    text: normalized === 'asap'
      ? 'ASAP'
      : this.toTitleCase(normalized.replace(/_/g, ' ')),
    color: deliverySpeedColorMap[normalized] || '#000',
  };
}
private toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

  loginSearch() {
    const url = `${env.API_BASE_HREF}login`;

    return this.httpService.post(url, {
      "username": "farzad",
      "password": "asd794613"
    });
  }

  searchProducts(search: string,
    pageNo: number, imgData?: any) {

    const formData = new FormData();
    formData.append('query', search);
    formData.append('page', '' + pageNo);
    if (imgData) {
      if (imgData.image_upload) formData.append('image_upload', imgData.image_upload);
      if (imgData.image_url) formData.append('image_url', imgData.image_url);
      if (imgData.partner_tier) formData.append('partner_tier', imgData.partner_tier);

    }
    const token = this.cookie.get("token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    const url = `${env.API_BASE_HREF}search_products`;
    return this.httpService.post(url, formData, headers);
  }
  getDesignEmailLog(roomId:any) {
    const url = `${env.API_BASE_HREF}get_design_email_log?room_id=${roomId}`;
    return this.httpService.get(url);
  }
    getAllDesignEmailLog() {
    const url = `${env.API_BASE_HREF}get_design_email_log`;
    return this.httpService.get(url);
  }
  getProductSpecs(sku){
    const url = `${env.API_BASE_HREF}get_product_specs?parent_sku=${sku}`;
    return this.httpService.get(url);
  }
   getShippingCodes(){
    const url = `${env.ADMIN_API_BASE_HREF}getShippingCodes`;
    return this.httpService.get(url);
  }
  
  createNote(payload: { room_id: number; note_body: string; is_private: number; }) {
    const url = `${env.API_BASE_HREF}design-notes`;
    return this.httpService.post(url, payload);
  }

  updateNote(note_id: number,payload:any ) {
    const url = `${env.API_BASE_HREF}design-notes/${note_id}`;
    return this.httpService.post(url, payload);
  }

  archiveNote(note_id: number,payload:any ) {
    const url = `${env.API_BASE_HREF}design-notes/archive/${note_id}`;
    return this.httpService.post(url, payload);
  }
  deleteNote(note_id: number) {
    const url = `${env.API_BASE_HREF}delete-design-notes/${note_id}`;
    return this.httpService.post(url,{});
  }
  getNotes(roomId: number) {
    const url = `${env.API_BASE_HREF}design-notes?room_id=${roomId}`; // ?room_id=${roomId}
    return this.httpService.get(url);
  }

      replyNote(payload: any, note_id: number) {
    const url = `${env.API_BASE_HREF}design-notes/replies/${note_id}`;
    return this.httpService.post(url, payload);
  }
  updateReply(payload:any,reply_id: number ) {
    const url = `${env.API_BASE_HREF}design-note-replies/${reply_id}`;
    return this.httpService.post(url, payload);
  }
  deleteReply(reply_id: number) {
    const url = `${env.API_BASE_HREF}delete-design-notes-replies/${reply_id}`;
    return this.httpService.post(url,{});
  }

  updateMilestoneDueDate(data){
    const url = `${env.API_BASE_HREF}update_milestone_due_date`;
    return this.httpService.post(url, data);
  }


  generateGiftCards(data) {
    const url = `${env.API_BASE_HREF}gift_cards`;
    return this.httpService.post(url,data);
  //  return of({
  //     success: true,
  //     message: 'Gift cards generated successfully',
  //     data: [] // replace with actual data
  //   });
  } 
  getGiftCardReceipt(orderId){
    const url = `${env.API_BASE_HREF}gift_cards/receipt/${orderId}`;
    return this.httpService.get(url);
  }
  reorderDPPosition(data){

    const url = `${env.API_BASE_HREF}reorder_dp_position`;
    return this.httpService.post(url, data);
  }
  getStyleGenomeList(){
        const url = `${env.API_BASE_HREF}get_stylegenome_list`;
    return this.httpService.get(url);
  }


  getRoomProfileChanges(roomId:string, unseenOnly = 1) {
    const url = `${env.API_BASE_HREF}room-profile-changes?room_id=${roomId}&unseen_only=${unseenOnly}`;
    return this.httpService.get(url);
  }


  markRoomProfileChangesSeen(roomId:string) {
    const url = `${env.API_BASE_HREF}room-profile-changes/mark-seen`;
    return this.httpService.post(url, { room_id: roomId });
  }

  checkImageAccessible(url: string): Promise<boolean> {
  // return new Promise((resolve) => {
  //   if (!url) {
  //     resolve(false);
  //     return;
  //   } 
  //   const img = new Image();
  //   img.onload = () => resolve(true);
  //   img.onerror = () => resolve(false);
  //   img.src = url;
  // });
    return new Promise((resolve) => {
    if (!url) return resolve(false);

    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);

    // Don’t trigger CORS or referrer blocking
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';

    // Use HEAD-style preload to avoid full fetch
    img.src = url + (url.includes('?') ? '&' : '?') + 'chk=' + Date.now();
  });
}

}
